import {observer} from "@legendapp/state/react";
import {DateTime} from "luxon";
import {$currentTime, diff2time} from "_utils/time";

export const TimeDiff = observer(({time}: { time: string | DateTime }) => {
    return (<>
        {diff2time($currentTime.get(), time)}
    </>)
});
